import { PageController } from '@client/components/_core/layout/PageController';
import { NewRegisterAction } from '@client/components/registers/NewRegisterAction';
import { RegistersList } from '@client/components/registers/RegistersList';
import { createFileRoute, Outlet } from '@tanstack/react-router';

// The registers list is a pathless layout rather than an index route so that the "Add a register"
// gallery (`add`) and the custom builder (`new`) can be overlay routes drawn over it, while the
// register detail pages stay full pages beside it (CUR-1338).
export const Route = createFileRoute('/console/$orgId/compliance/registers/_list')({
    staticData: {
        ui: {
            title: 'Registers',
            // One line, no full stop, no marketing voice. The previous copy ran
            // to two lines and squeezed the header's New register button until
            // its label wrapped.
            subtitle: 'Records your business keeps, linked to the risks, controls and obligations they belong to',
            // The index child has no title of its own; it shows this one.
            useTitleForChildren: true,
        },
    },
    component: RegistersListLayout,
});

function RegistersListLayout() {
    return (
        <PageController route={Route}>
            {/* Shown while an overlay child is open; the index child renders it otherwise. */}
            <NewRegisterAction />
            <RegistersList />
            <Outlet />
        </PageController>
    );
}
